import React, { useState, useEffect, useContext, useImperativeHandle, forwardRef } from 'react'
import { Dropdown } from 'primereact/dropdown';
import axios from 'axios';
import { UserContext } from '../../hooks/UserContext';
import { ContentContext } from '../../hooks/ContentContext';
import { loadLastEdited } from '../../services/editorSession';
import qs from 'qs';


const SelectCourse = forwardRef(({ searchQuery }, ref) => {
  const [selectOptions, setSelectOptions] = useState([]);
  const { user } = useContext(UserContext);
  const { selectedCourse, handleCourseChange } = useContext(ContentContext);

  useEffect(() => {
    getOptions();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useImperativeHandle(ref, () => ({
    refresh: () => getOptions(),
  }));

  const getOptions = async () => {
    try {
      let options = [];
      let currentPage = 1, totalPages;

      do {
        const { data } = await axios.get(`/api/courses?page=${currentPage}&per_page=100`, {
          headers: {
            'Authorization': `Bearer ${user.token}`,
            'X-EDITOR': 'nanoms'
          }
        });

        options = [...options, ...data.items.map(({ id, name, topics }) => ({
          value: id,
          label: name,
          id,
          topics: topics || 0
        }))];

        totalPages = data._meta.total_pages;
        currentPage++;
      } while (currentPage <= totalPages);

      setSelectOptions(options);

      if (searchQuery) {
        const { course } = qs.parse(searchQuery, { ignoreQueryPrefix: true });
        const result = options.find(({ value }) => value === parseInt(course));
        if (result) {
          handleCourseChange({ id: result.value, name: result.label });
          return;
        }
      }

      if (selectedCourse.id) return;

      // Reopen the course last worked on in the editor
      const last = loadLastEdited();
      if (last) {
        const result = options.find(({ value }) => value === last.courseId);
        if (result) {
          handleCourseChange({ id: result.value, name: result.label });
          return;
        }
      }

      // Auto-select first course if none selected
      if (options.length > 0) {
        handleCourseChange({ id: options[0].value, name: options[0].label });
      }
    } catch (error) {
      console.error(error);
    }
  }

  const handleChange = (e) => {
    const result = selectOptions.find(({ value }) => value === e.value);
    if (result) {
      handleCourseChange({ id: result.value, name: result.label });
      console.log(`Selected course with id: ${e.value}`);
    }
  }

  const itemTemplate = (option) => {
    return (
      <div style={{ padding: '4px 0' }}>
        <div style={{
          fontSize: '13px',
          fontWeight: 500,
          color: '#18181b',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          lineHeight: '1.3'
        }}>
          {option.label}
        </div>
        <div style={{ fontSize: '11px', color: '#a1a1aa', marginTop: '2px' }}>
          ID: {option.id} · {option.topics} {option.topics === 1 ? 'topic' : 'topics'}
        </div>
      </div>
    );
  };

  const valueTemplate = (option, props) => {
    if (option) {
      return (
        <div
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '300px'
          }}
          title={option.label}
        >
          {option.label}
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  return (
    <div className="selectbox">
      <Dropdown
        value={selectedCourse.id}
        options={selectOptions}
        onChange={handleChange}
        placeholder="Select a Course"
        optionLabel="label"
        filter
        filterBy="label"
        filterPlaceholder="Search courses..."
        itemTemplate={itemTemplate}
        valueTemplate={valueTemplate}
        panelStyle={{ width: '600px' }}
        virtualScrollerOptions={{ itemSize: 56 }}
      />
    </div>
  )
});

export default SelectCourse;
